import styled, { keyframes } from 'styled-components';
import { CompletedFieldIcon } from '../icons/CompletedFieldIcon';
import React from 'react';
import GptIcon from 'components/Icons/gpt.svg';

const CheckIconWrapper = styled.div<{ $isAi: boolean; $top: number; $right: number; $size: Size; $iconSize: Size }>`
  display: flex;
  position: absolute;
  top: ${props => props.$top}px;
  right: ${props => props.$right}px;
  width: ${props => props.$size.width}px;
  height: ${props => props.$size.height}px;
  z-index: 99;
  align-items: center;
  justify-content: center;

  svg {
    width: ${props => props.$iconSize.width}px;
    height: ${props => props.$iconSize.height}px;
  }

  ${props => props.$isAi && `border: 1px solid #fff; border-radius: 100%`};
`;

type Size = {
  width: number;
  height: number;
};

type Props = {
  iconType: 'checkmark' | 'ai';
  top?: number;
  right?: number;
  size?: Size;
  iconSize?: Size;
};

export const NotesTopIcon: React.FC<Props> = ({
  iconType,
  size = { width: 11, height: 11 },
  iconSize = { width: 11, height: 11 },
  top = 3,
  right = 4
}) => {
  return (
    <CheckIconWrapper $size={size} $iconSize={iconSize} $top={top} $right={right} $isAi={iconType === 'ai'}>
      {iconType === 'ai' ? <GptIcon /> : <CompletedFieldIcon />}
    </CheckIconWrapper>
  );
};
